import React from "react";
import { useLocation } from "react-router-dom"; 
import { useSelector } from 'react-redux';
import DataRecords from "../../components/DataRecords";
import OnBoardingForm from "../../components/onboarding/OnBoardingForm";
import OnBoardingHead from "../../components/onboarding/OnBoardingHead";
import CommonHeader from "../../components/HeaderComponent/CommonHeader";

const OnBoarding = () => {
  const location = useLocation();  // Access the current location object
  const { rowData, type } = location.state || {}; 
  const { user } = useSelector((state) => state.user)

  return (
    <div className="main-board">
      <div className="onboarding-page-container">
        <div className="onboarding-page-header">
          {
            type == "new" ? (
              <CommonHeader 
                headerKey="onboarding_page"
                headerTitle="On-boarding New Vessel" 
                headerSubTitle=""
                type={type}
              />
            ) : type == "view" ? (
              <CommonHeader 
                headerKey="onboarding_page"
                headerTitle="On-boarded Vessel" 
                headerSubTitle=""
                type={type}
              />
            ) : type == "edit" ? (
              <CommonHeader 
                headerKey="onboarding_page"
                headerTitle="Modify On-boarded Vessel" 
                headerSubTitle=""
                type={type}
              />
            ) : null
          }
        </div>

        
        <OnBoardingForm type={type} rowData={rowData} /> {/* Pass rowData and type to the form */}
      </div>
    </div>
  );
};

export default OnBoarding;
